import React from 'react';
import styled from 'styled-components';
import { useProjectElementListStore } from '../../shared/store/projectElementStore';
import { DocumentData } from '../../shared/dto/EntityRepository';
import { DisplaySize, DisplayAlignment, ImageStyle } from '../../shared/enum/EnumRepository';
import { ImgInPeWrapper, WorkImageForLandscape, WorkImageForPortrait } from './WorkImgInPe';
import { convertS3UrlToCloudFrontUrl } from '../../shared/aws/awsHelper';
import OptimizedMoleculeImg from '../../shared/component/molecule/OptimizedMoleculeImg';
import { StyledImgProps } from '../../shared/dto/StyleCompRepository';
import { useEditMode } from '../../shared/hooks/useEditMode';
import UniversalIconBtn from '../../shared/component/headless/button/UniversalIconBtn';
import HintWrapper from '../../shared/component/headless/button/HintWrapper';
import { getHintMessage } from '../../shared/constants/hintMessages';
import videoIcon from '../../asset/icon/video.png';


export interface DocumentImgInPeProps {
  peId: string;
  alignment: DisplayAlignment;
  displaySize: DisplaySize;
  data: DocumentData;
  priority: boolean;
  imageStyle: ImageStyle;
  onChangeType?: () => void;
}

const DocumentImgInPe: React.FC<DocumentImgInPeProps> = ({ peId, alignment, displaySize, data, priority, imageStyle, onChangeType }) => {
  const { isEditMode } = useEditMode();
  const handleImageChange = useProjectElementListStore((s) => s.updateImage);
  const convertedCloudFrontUrl = convertS3UrlToCloudFrontUrl(data.uploadFile.originUrl);
  const imageRatio = data.uploadFile?.width && data.uploadFile?.height
    ? data.uploadFile.width / data.uploadFile.height
    : undefined;

  const getStyledImage = () => {
    if (imageStyle === ImageStyle.LANDSCAPE) {
      return WorkImageForLandscape as React.ComponentType<StyledImgProps>;
    } else {
      return WorkImageForPortrait as React.ComponentType<StyledImgProps>;
    }
  };

  return (
    <ImgInPeWrapper
      $alignment={alignment || DisplayAlignment.CENTER}
      $displaySize={displaySize || DisplaySize.REGULAR}
      $imageStyle={imageStyle || ImageStyle.LANDSCAPE}>
      <OptimizedMoleculeImg
        srcUrl={convertedCloudFrontUrl}
        alt={data.description}
        displaySize={displaySize || DisplaySize.REGULAR}
        displayAlignment={alignment || DisplayAlignment.CENTER}
        handleChange={(originUrl: string, width: number, height: number) =>
          handleImageChange(
            peId,
            originUrl,
            width,
            height
          )}
        StyledImg={getStyledImage()}
        priority={priority}
        imageRatio={imageRatio}
      />
      {isEditMode && onChangeType && (
        <EditTransparentLayer>
          <EditBtnContainer>
            <HintWrapper
              content={getHintMessage('CHANGE_DETAIL_TYPE', { detailType: 'Video' })}
              toLeft={true}
            >
              <UniversalIconBtn
                size="fit"
                border={true}
                backgroundImg={videoIcon}
                onClick={onChangeType}
              />
            </HintWrapper>
          </EditBtnContainer>
        </EditTransparentLayer>
      )}
    </ImgInPeWrapper>
  );
}

const EditTransparentLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: linear-gradient(to right, transparent 50%, ${({ theme }) => theme.colors.color_Gray_06} 150%);
  backdrop-filter: blur(0px);
  &:hover {
    opacity: 1;
    backdrop-filter: blur(2px);
  }
  transition: all 0.6s ease-in-out;
  cursor: default;
`;

const EditBtnContainer = styled.div`
  position: absolute;
  right: 0.5vh;
  top: 0.5vh;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5vh;
`;


export default DocumentImgInPe;